export const ENTER_OTP_TITLE = 'Authentication App Code';
export const ENTER_OTP_BACKUP_CODE_TITLE = 'Authentication Backup Code';
export const ENTER_OTP_SUBTITLE = 'Enter the 6-digit code from your authentication app.';
export const ENTER_OTP_BACKUP_CODE_SUBTITLE
  = 'Enter one of the backup codes provided when setting up two-factor authentication.';
export const AUTH_CODE_LENGTH = 6;
export const AUTH_BACKUP_CODE_LENGTH = 8;
export const AUTH_RECOVERY_CODE_LENGTH = 6;
export const AUTH_BACKUP_CODE_LABEL = 'Backup code';
export const AUTH_BACKUP_CODE_MESSAGE
  = 'Individual backup codes can only be used once. Update your two-factor authentication settings and generate new codes after logging in.';
export const AUTH_CODE_LABEL = 'Authentication Code';
export const AUTH_CODE_PLACEHOLDER = 'Enter code';
export const AUTH_OTP_REMEMBER_COOKIE_PREFIX = 'scalar_auth_otp_remember';
export const AUTH_OTP_REMEMBER_LEGACY_COOKIE_PREFIX = 'scalar_otp';
export const OTP_REMEMBER_DEVICE_LABEL = 'Skip two-factor authentication on this computer for 60 days';
export const OTP_REMEMBER_DEVICE_DAYS = 60;
export const AUTH_CODE_ERROR_LENGTH_OR_TYPE = 'Must be a 6-digit number.';
export const AUTH_BACKUP_CODE_ERROR_LENGTH_OR_TYPE = 'Enter a valid 8-character backup code.';
export const INVALID_OTP_ERROR = 'Invalid code. Please wait for the next code and try again.';
export const MISSING_BACKUP_CODE = 'Backup code is required.';
export const SETUP_2FA_TITLE = 'Two Factor Setup';
export const SETUP_2FA_SUBTITLE
  = 'Take these few steps to enable two-factor authentication and make your account more secure.';
export const SETUP_2FA_STEP_1
  = 'Install an authenticator app on your mobile device. Recommended options: Google Authenticator, Authy, Microsoft Authenticator.';
export const SETUP_2FA_STEP_2 = 'Scan QR code with the authenticator app (or enter the key manually).';
export const SETUP_2FA_STEP_3 = 'Enter the 2-step authentication code provided by your app.';
export const MESSAGE_BOX_TITLE_SUCCESS = 'Confirmation';
export const RESULT_SUCCESS = 'enabled!';
export const CONFIRMATION_BUTTON_NEXT = 'Next';
export const CONFIRMATION_BUTTON_BACK = 'Back';
export const OTP_VERIFICATION_BACK_LABEL = 'Back';
export const OTP_VERIFICATION_LOG_OUT_LABEL = 'Sign out';
export const OTP_VERIFICATION_NEXT_LABEL = 'Next';
export const OTP_VERIFICATION_NOT_WORKING_LABEL = 'Code not working?';
export const OTP_NO_BACKUP_CODES_LABEL = 'I also don\'t have my backup codes';
export const OTP_RECOVERY_REQUEST_TITLE = 'Account Recovery';
export const OTP_RECOVERY_REQUEST_SUBTITLE
  = 'We can email you a one-time recovery code. Using it will remove your current authenticator app and backup '
  + 'codes, so you\'ll need to set up two-factor authentication again from scratch.';
export const OTP_RECOVERY_REQUEST_BUTTON_LABEL = 'Email me a recovery code';
// Each of these is completed by a retry hint, so none of them ends in advice of its own.
export const OTP_TOO_MANY_ATTEMPTS_MESSAGE = 'Too many attempts.';
export const OTP_TOO_MANY_RECOVERY_REQUESTS_MESSAGE = 'Too many recovery code requests.';
export const OTP_TRY_AGAIN_LATER_MESSAGE = 'Please try again later.';
export const OTP_RECOVERY_REQUEST_GENERIC_ERROR = 'We couldn\'t send a recovery code right now. Please try again.';
export const OTP_RECOVERY_VERIFY_TITLE = 'Enter Recovery Code';
export const OTP_RECOVERY_VERIFY_SUBTITLE = 'Enter the 6-digit code we emailed you. It expires in 15 minutes.';
export const OTP_RECOVERY_CODE_LABEL = 'Recovery code';
export const OTP_RECOVERY_CODE_ERROR_LENGTH_OR_TYPE = 'Must be a 6-digit number.';
export const MISSING_RECOVERY_CODE = 'Recovery code is required.';
export const OTP_RECOVERY_RESEND_LABEL = 'Resend code';
export const OTP_RECOVERY_GENERIC_VERIFY_ERROR = 'Something went wrong. Please try again.';
export const OTP_SETUP_ENABLE_LABEL = 'Enable';
export const OTP_RESULT_SUCCESS_MESSAGE = 'Two-factor authentication enabled!';
export const SUCCESS_INSIDE = 'success-inside';
export const KEEP_STATIC_CODES_SAFE = 'Keep these codes safe, but accessible.';
export const BACKUP_CODES = 'Backup Codes';
export const USE_BACKUP_CODES = `If you lose access to your authentication device, you can use one of these ${BACKUP_CODES.toLowerCase()} to sign in to your account. Each code may be used only once. Make a copy of these codes and store it somewhere safe.`;
export const PAGE_TITLE = 'Two Factor Authentication';
export const NO_BACKUP_CODES_AVAILABLE = `No ${BACKUP_CODES.toLowerCase()} available`;
export const GENERATE_NEW_CODES = 'Generate new codes';
export const PRINT_CODES = 'Print codes';
export const COPY_CODES = 'Copy codes';
export const OK_COPY_CODES = `The ${BACKUP_CODES.toLowerCase()} were copied to the clipboard.`;
export const ERROR_COPY_CODES = `An error occurred while copying the ${BACKUP_CODES} to the clipboard.`;
export const CANNOT_UPDATE_2FA = 'Cannot update 2FA settings at this time. Please try again later.';
export const THESE_ARE_YOUR_NEW_BACKUP_CODES = 'These are your new backup codes';
export const AFTER_YOU_USE_A_BACKUP_CODE
  = 'After you use a backup code to sign in, it becomes inactive. You can generate a new set of 10 codes whenever you want. After creating a new set, the old set automatically becomes inactive.';
export const DONE_CODES = 'Done';
export const DOWNLOAD_CODES = 'Download codes';
export const SUCCESS_DOWNLOAD_CODES = `The file with your ${BACKUP_CODES.toLowerCase()} has been downloaded successfully.`;
export const ERROR_DOWNLOAD_CODES = `An error occurred while downloading the file with your ${BACKUP_CODES}.`;
export const SHOW_KEY = 'Show Key';
export const HIDE_KEY = 'Hide Key';
export const COPY_KEY = 'Copy key';
export const KEY_COPIED = 'Key copied to clipboard.';
export const REAUTHENTICATION_MESSAGE
  = 'We\'ve noticed that you need to reauthenticate to generate new backup codes. To do so, please sign out and then sign in again.';
export const TWO_FA_ORG_MANDATORY_HINT
  = 'Your organization requires two-factor authentication. You cannot turn it off while this policy is in effect.';
